import * as React from 'react';
import Button from '@mui/material/Button';
import { withTranslation } from "react-i18next";

export interface ButtonProps {
    label: string;
    variant: 'text' | 'contained' | 'outlined';
    style?: React.CSSProperties;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    color?: any;
    // i18n translation function from withTranslation
    t: any;
}

function BasicButtons({ label = 'send', variant, style, onClick = () => { }, disabled = false, color = 'primary', t }: ButtonProps) {
    const translatedLabel = t(label);
    return (
        <Button
            variant={variant}
            style={style}
            onClick={onClick}
            disabled={disabled}
            color={color}
        >
            {translatedLabel}
        </Button>
    );
}

export default withTranslation("translation")(BasicButtons);